import React, { useEffect } from "react";
import { Grid, Container } from "@mui/material";
import "../../style/home/clientes/clientes.css"
import AOS from 'aos';
import 'aos/dist/aos.css';

/* import grupales imagenes */
import quimicos from  "../../img/home/cliente/clientes-quimica.jpg"
import mineria from  "../../img/home/cliente/clientes-mineria.jpg"
import energia from  "../../img/home/cliente/clientes-energia.jpg"



export default function Clienteshome() {
  
  useEffect(() => {
    AOS.init({
      duration: 1000, // Duración de las animaciones en milisegundos
      once: true, // Solo realiza las animaciones una vez
    });
  }, []);

  
  const dataMineria = [
    { image: mineria, title: "Minería", seo:"servicios industriales" },

  ];


  const dataEnergia = [
    { image: energia, title: "Energía", seo:"servicios industriales" },

  ];

  
  const dataQuimicaTransporte = [
    { image:quimicos, title: "Química y Transporte", seo:"servicios industriales" },

  ];
 
  return (
    <section  data-aos="fade-down">
      <Container  maxWidth="md" sx={{marginTop:'50px', marginBottom:'100px', display:'flex', alignItems:'center', justifyContent:'center'}}>
      <div className="contienecliente">
        <section className="titulo-informacion-cliente">
          <h2 alt="servicios industriales">Quienes han confiado en nosotros</h2>
        </section>
        <Grid container className="clienhom">
        
          <Grid item xs={12} sm={6} md={4}>
            <div className="contiene-mineria">
              <h1>Minería</h1>
              {dataMineria.map((item, index) => (
                <img key={index} src={item.image} alt={item.seo}   title={item.seo} />
              ))}
            </div>
          </Grid>

         
          <Grid item xs={12} sm={6} md={4}>
            <div className="contiene-mineria">
              <h1 alt="servicios industriales">Energía</h1>
              {dataEnergia.map((item, index) => (
                <img key={index} src={item.image} alt={item.seo}    title={item.seo}/>
              ))}
            </div>
          </Grid>

       
          <Grid item xs={12} sm={6} md={4}>
            <div className="contiene-mineria">
              <h1 alt="servicios industriales">Química y Transporte</h1>
              {dataQuimicaTransporte.map((item, index) => (
                <img key={index} src={item.image}  alt={item.seo}    title={item.seo} />
              ))}
            </div>
          </Grid>
        </Grid>
      </div>
      </Container>
    </section> 
  );
}